<template>
  <div>
    <filter-panel :data="group" @search="filterChange"></filter-panel>
    <data-list
      :table-style="{ name: 'mixture' }"
      :data="data"
      :columns="columns"
      :loading="loading"
      :page="page"
      :page-size="page.pageSize"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
    ></data-list>
  </div>
</template>

<script>
import { reportType } from '@/common/dictionary.js';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import listPageCreate from '@/mixins/listPageCreate';
import customer from '@/mixins/customer';
import api from '@/backend/apiConfig/apiConfig';

const page = listPageCreate({
  searchConfig: {
    api: api.customer.resultsReportList,
    method: 'POST'
  }
});

export default {
  mixins: [page, customer],
  data() {
    let that = this;
    return {
      group: {
        others: [
          {
            tagName: 'sky-input',
            placeholder: '服务人员',
            label: '服务人员',
            prop: 'serviceStaffName',
            value: ''
          }
        ],
        multiples: [
          {
            defaultText: '报告类型',
            placeholder: '报告类型',
            label: '报告类型',
            options: reportType,
            prop: 'type',
            value: ''
          },
          {
            defaultText: '推送状态',
            placeholder: '推送状态',
            label: '推送状态',
            options: [
              { label: '已推送', value: true },
              { label: '未推送', value: false }
            ],
            prop: 'flagPushStatus',
            value: ''
          },
          {
            defaultText: '是否已读',
            placeholder: '是否已读',
            label: '是否已读',
            options: [
              { label: '是', value: true },
              { label: '否', value: false }
            ],
            prop: 'flagRead',
            value: ''
          }
        ]
      },
      columns: [
        {
          label: '客户名称',
          type: 'custInfo',
          text: [
            {
              bind: 'customerName'
            }
          ]
        },
        {
          label: '服务人员',
          bind: 'serviceStaffName'
        },
        {
          label: '报告类型',
          bind: 'type',
          type: 'mapping',
          mapType: 'text',
          parentEvent(val) {
            if (!val) return '-';
            switch (val) {
              case 1:
                return '周报';
              case 2:
                return '月报';
            }
          }
        },
        {
          label: '推送状态',
          bind: 'flagPushStatus',
          type: 'popoverView',
          formatter(val) {
            switch (val) {
              case true:
                return '已推送';
              case false:
                return '未推送';
            }
          },
          setdisabled(val) {
            return val;
          },
          subtext() {
            return 'CID数据查询失败';
          }
        },
        {
          label: '推送日期',
          bind: 'pushTime'
        },
        {
          label: '是否已读',
          bind: 'flagRead',
          type: 'popoverView',
          formatter(val) {
            switch (val) {
              case true:
                return '是';
              case false:
                return '否';
            }
          },
          setdisabled(val) {
            return !val;
          },
          subtext(row, tableData) {
            if (
              !row[tableData.bind] ||
              !row.readList ||
              row.readList.length == 0
            ) {
              return '-';
            }
            return `${row.readList[0].accountName || '-'} \xa0\xa0\xa0  ${row
              .readList[0].createTime || '-'}`;
          }
        },
        {
          label: '操作',
          type: 'btnClick',
          align: 'center',
          bind: [
            {
              text: '查看报告',
              showButton() {
                return that.getPermission(
                  that.$permissionData.resultsReportCheckReport.englishName
                );
              },
              trigger(row) {
                that.$router.push({
                  name: 'reportDetail',
                  query: {
                    id: row.customerId,
                    type: row.type
                  }
                });
              }
            }
          ]
        }
      ]
    };
  },
  mounted() {
    this.query();
  },
  methods: {},
  components: { filterPanel }
};
</script>

<style></style>
